if (!customElements.get('pw-craft-film')) {
  customElements.define('pw-craft-film', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.video = this.querySelector('video');
      this.still = this.querySelector('.pw-craft-still');
      try { this.variants = JSON.parse(this.querySelector('[data-craft-variants]').textContent).variants; } catch { return; }
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.autoPlay = true;
      this.update = () => {
        const id = document.querySelector('form[action*="/cart/add"] input[name="id"]')?.value || this.dataset.initial;
        const variant = this.variants.find(item => String(item.id) === String(id));
        if (!variant || this.currentId === id) return;
        this.removeAttribute('data-playing');
        this.currentId = id;
        if (this.still) {
          this.still.srcset = variant.srcset || '';
          this.still.src = variant.image;
          this.still.alt = variant.title;
        }
        this.toggleAttribute('data-editorial', variant.editorial === true);
        this.stillOnly = !this.video;
        this.toggleAttribute('data-still-only', this.stillOnly);
        this.toggleAttribute('data-unavailable', this.stillOnly && !variant.image.trim());
        if (this.stillOnly) {
          this.video?.pause();
          this.removeAttribute('data-playing');
        } else if (this.inView && this.autoPlay && !this.userPaused) this.play();
        this.syncFrame();
      };
      document.addEventListener('change', event => {
        if (event.target.matches('input[name="id"], variant-radios input, variant-selects select')) queueMicrotask(this.update);
      }, options);
      window.addEventListener('popstate', this.update, options);
      this.update();
      this.setAttribute('data-ready', '');
      if (!this.video) return;
      this.video.muted = true;
      this.pauseButton = document.createElement('button');
      this.pauseButton.type = 'button';
      this.pauseButton.className = 'pw-video-toggle';
      this.pauseButton.innerHTML = '<span aria-hidden="true">Ⅱ</span>';
      this.pauseButton.setAttribute('aria-label', 'Pause video');
      const updateButton = () => {
        this.pauseButton.setAttribute('aria-label', this.video.paused ? 'Play video' : 'Pause video');
        this.pauseButton.firstElementChild.textContent = this.video.paused ? '▶' : 'Ⅱ';
      };
      this.pauseButton.addEventListener('click', () => {
        if (this.video.paused) { this.userPaused = false; this.video.play().catch(() => {}); }
        else { this.userPaused = true; this.video.pause(); }
      });
      this.video.addEventListener('playing', updateButton);
      this.video.addEventListener('pause', updateButton);
      this.append(this.pauseButton);

      this.video.addEventListener('timeupdate', () => this.syncFrame(), options);
      this.video.addEventListener('playing', () => {
        this.setAttribute('data-playing', '');
        this.syncFrame();
      }, options);
      this.video.addEventListener('error', () => {
        this.removeAttribute('data-playing');
        this.setAttribute('data-still-only', '');
      }, options);
      this.preloader = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting) && this.offsetWidth) this.prepare();
      }, {rootMargin:'200px 0px'});
      this.preloader.observe(this);
      this.observer = new IntersectionObserver(entries => {
        this.inView = entries.some(entry => entry.isIntersecting && entry.intersectionRatio >= 0.1);
        if (this.inView && this.autoPlay && !this.userPaused) this.play();
        else if (!this.inView) this.video.pause();
      }, { threshold: [0, 0.1] });
      this.observer.observe(this);
    }
    syncFrame() {
      if (!this.video) return;
      this.toggleAttribute('data-process', !this.stillOnly);
    }
    prepare() {
      if (!this.video || this.loaded) return;
      this.video.querySelectorAll('source[data-src]').forEach(source => { source.src = source.dataset.src; });
      this.loaded = true;
      this.video.preload = 'auto';
      this.video.load();
    }
    play() {
      if (this.stillOnly) return;
      this.prepare();
      this.video.play().then(() => {
        this.setAttribute('data-playing', '');
        this.syncFrame();
      }).catch(() => {});
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.preloader?.disconnect();
      this.video?.pause();
    }
  });
}
